import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function NavHeader2() {
  const [loginUser, setLogInUser] = useState("");

  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("userVASData");
    localStorage.removeItem("companyData");
    localStorage.removeItem("companyVASData");
    localStorage.removeItem("companyName");
    navigate("/login");
  };

  useEffect(() => {
    // Retrieve userVASData from localStorage
    const storedUserData = localStorage.getItem("userVASData");
    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      setLogInUser(userData.responseDetails.userName);
    }
  }, []);

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <div className="search_bar">
                <img
                  src="../assets/images/vas.png"
                  style={{ width: "80px" }}
                  alt=""
                />
              </div>
            </div>

            <ul className="navbar-nav header-right">
              {/* <li className="nav-item dropdown notification_dropdown">
                                <a className="nav-link bell-link" href="javascript:void(0);">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22.871" viewBox="0 0 24 22.871">
                                    <g data-name="Layer 2" transform="translate(-2 -2)">
                                    <path id="Path_9" data-name="Path 9" d="M23.268,2H4.73A2.733,2.733,0,0,0,2,4.73V17.471A2.733,2.733,0,0,0,4.73,20.2a.911.911,0,0,1,.91.91v1.94a1.82,1.82,0,0,0,2.83,1.514l6.317-4.212a.9.9,0,0,1,.5-.153h4.436a2.742,2.742,0,0,0,2.633-2L25.9,5.462A2.735,2.735,0,0,0,23.268,2Zm.879,2.978-3.539,12.74a.915.915,0,0,1-.88.663H15.292a2.718,2.718,0,0,0-1.514.459L7.46,23.051v-1.94a2.733,2.733,0,0,0-2.73-2.73.911.911,0,0,1-.91-.91V4.73a.911.911,0,0,1,.91-.91H23.268a.914.914,0,0,1,.879,1.158Z" transform="translate(0 0)"></path>
                                    <path id="Path_10" data-name="Path 10" d="M7.91,10.82h4.55a.91.91,0,1,0,0-1.82H7.91a.91.91,0,1,0,0,1.82Z" transform="translate(-0.45 -0.63)"></path>
                                    <path id="Path_11" data-name="Path 11" d="M16.1,13H7.91a.91.91,0,1,0,0,1.82H16.1a.91.91,0,1,0,0-1.82Z" transform="translate(-0.45 -0.99)"></path>
                                    </g>
                                </svg>
                                    <span className="badge light text-white bg-primary rounded-circle">76</span>
                                </a>
                            </li> */}
              <li className="nav-item dropdown header-profile">
                <a
                  className="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  <img
                    src="../assets/images/avatar.png"
                    className="avatar"
                    alt=""
                  />
                </a>
                <p style={{ marginTop: 15, paddingLeft: 2, color: "#ccc" }}>
                  {" "}
                  {loginUser || "Guest"}
                </p>

                <div className="dropdown-menu dropdown-menu-right">
                  <Link to="#" className="dropdown-item ai-icon">
                    <i
                      className="la la-cog"
                      style={{
                        fontSize: "20px",
                        top: "2px",
                        position: "relative",
                        color: "#222",
                      }}
                    ></i>
                    <span className="ms-2">Profile</span>
                  </Link>
                  <Link
                    onClick={logout}
                    to="/"
                    className="dropdown-item ai-icon"
                  >
                    <i
                      className="la la-power-off"
                      style={{
                        fontSize: "20px",
                        top: "2px",
                        position: "relative",
                        color: "#222",
                      }}
                    ></i>
                    <span className="ms-2">Logout </span>
                  </Link>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
}
